<template>
  <div class="my-layout-box p-custom-message">
    <list-view
      :getList="getList"
      :isTabsShow="isTabsShow"
      :isButtonShow="isButtonShow"
      :isSearchShow="isSearchShow"
      :listMap="listMap"
    >
    </list-view>
  </div>
</template>

<script>
import listView from "~/components/List/ListView.vue";
import { itemsData } from "./config";
import { getCustomMessage } from "~/api/userCenter";
export default {
  name: "salesMan",
  components: {
    listView
  },
  data() {
    return {
      isTabsShow: false,
      isButtonShow: false,
      isSearchShow: false,
      listMap: itemsData,
      mapOption: {
          HKReceipt: '香港正能量入仓',
          PassCustoms: '通关状态(正常/异常)',
          SZDelivery: '深证正能量送货',
          AuditOrder: '下单审核',
        }
    };
  },

  methods: {
    async getList(pagination, searchData) {
      let sendData = {
        page: pagination.page,
        limit: pagination.size
      };
      searchData.value = searchData.value;
      const list = await getCustomMessage(searchData);
      list.Items.forEach((item, index) => {
          item.CustomizedStr = []
          item.RowIndex = index + 1
          Object.entries(this.mapOption).forEach(([key, value]) => {
            const line = item.CustomizedList.find(line => line == key)
            if (line) {
              item.CustomizedStr.push(value)
            }
          })
          item.CustomizedStr = item.CustomizedStr.join()

        })
      const data = {
        List: list.Items,
        Total: list.Total
      };
      return data;
    }
  }
};
</script>

<style lang="less" scope></style>
